import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
export var SignSource;
(function (SignSource) {
    SignSource[SignSource["NotSet"] = 0] = "NotSet";
    SignSource[SignSource["BankId"] = 1] = "BankId";
    SignSource[SignSource["DigitalSignature"] = 2] = "DigitalSignature";
})(SignSource || (SignSource = {}));
export class KeyValuePair {
}
class SigningDocumentResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.documentCode = "";
        this.documentIdList = [];
        this.documentName = "";
        this.hasSecurityDocument = false;
        this.read = false;
        this.partiallySigned = false;
        this.signed = false;
        this.canResetSignature = false;
        this.allowResetSignature = false;
        this.signersToSign = [];
        this.signers = [];
        this.signerTypes = [];
        this.signerTypesToRead = [];
        this.signSource = SignSource.NotSet;
        this.allowDocumentDownload = false;
        this.applicationNumber = "";
    }
    pk() {
        return this.esignTaskId?.toString();
    }
    static resetSignature() {
        return this.update().extend({
            url: params => this.url(params).replace(this.urlRoot, legacyApiResourceUrl("Signer/ResetEsignature"))
        });
    }
}
SigningDocumentResource.urlRoot = legacyApiResourceUrl("Signer/GetAvailableDocuments");
export { SigningDocumentResource };
//# sourceMappingURL=SigningDocumentResource.js.map